import { Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AnalyticsPageView from "@/components/AnalyticsPageView";
import { scheduleIdle } from "@/lib/scheduleIdle";
import Index from "./pages/Index";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";

// Privacy/Terms/NotFound are imported eagerly so the hydrated tree
// matches the SSG'd HTML exactly. lazy() on these routes caused the
// client's first render to fall back to <Suspense fallback={null}/>
// while SSR rendered full content — hydration mismatch (React #418).
// Three small marketing pages are ~10 KB combined gzipped; the hit
// is worth the hydration correctness.

// Inner tree without a router. Used by entry-server.tsx (wraps in
// StaticRouter for SSG) and by App below (wraps in BrowserRouter for
// the hydrated client). Both wrappers consume the SAME inner tree
// so hydration sees a 1:1 structural match.
export const AppRoutes = () => {
  useEffect(() => {
    scheduleIdle(() => {
      void import("@/lib/analytics").then((m) => m.initAnalytics());
    });
  }, []);

  return (
    <>
      <AnalyticsPageView />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

const App = () => (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <AppRoutes />
  </BrowserRouter>
);

export default App;
